import {NotifyManager} from 'notify-component';
import Modal from '#app/interface/modal/Modal';

export interface LoginFormInterface {
    email: string;
    password: string;
    code: string;
    form: string;
}

interface LoginResponseInterface {
    response: any;
    status: number;
    xhr: any;
}

export interface SuccessCallbacksListInterface {
    handleCloseModal: any,
    setForm: any,
    setSubmitted: any,
    callback: any
}

export const initialLoginFormState = {email: '', password: '', code: ''};
export const initialForbbiddenFormState: { email: string, password: string } = {email: '', password: ''};

export const handleLoginSuccess = (
    loginResponseObject: LoginResponseInterface,
    successCallbacksList: SuccessCallbacksListInterface,
) => {
    const {response, status, xhr} = loginResponseObject; // @FIXME Unused constant response Unused constant status
    const {handleCloseModal, setForm, setSubmitted, callback} = successCallbacksList;
    const header = xhr.getResponseHeader('Authorization');
    console.log(header);

    if (header) {
        localStorage.setItem('api_token', header);
        Modal.handleClose();
        handleCloseModal();
        setForm(initialLoginFormState);
        setSubmitted(false);

        if (typeof callback === 'function') callback();
    } else {
        NotifyManager.error('', 'Ошибка авторизации');
    }
}

export const handleLoginFailure = (
    type: any,
    responseData: any,
    setType: any,
    setSubmitted: any,
) => {
    if (type === '') {
        let enable = false;
        if (responseData?.meta?.errors?.code?.[0]) {
            if (responseData.meta.errors.code[0] === 'Неверный 2FA код') {
                enable = true;
            }

            setType(enable ? '2fa' : '');
            setSubmitted(false);
        }
    } else {
        setSubmitted(false);
    }
}